import { h } from 'preact';
import './external_target.scss';
import { createPortal } from 'preact/compat';
import { AdjacentTarget } from './adjacent_target';
import { VIEW_PAGE } from '../../../constants/events';

export const TARGET_SEARCH_INTERVAL_MS = 250;

export class ExternalTarget extends AdjacentTarget {
    constructor(...args) {
        super(...args);
        this.targetEl = document.createDocumentFragment();
        this.findTarget('constructor');

        // Inserts the quiz into the Lyceum activity panel when a user manually opens the panel.
        args[0].bus.on(VIEW_PAGE.RESET_ACTIVITY_PANEL_CONTENTS, () => { this.findTarget('') })
    }

    render(...args) {
        return createPortal(super.render(...args), this.targetEl)
    }

    findTarget = source => {
        const target = document.querySelector(this.targetName);

        clearTimeout(this.searchTimeout);

        if (target) {
            this.targetEl = target;          

            if (source !== 'constructor') {
                this.forceUpdate();
            }
        } else {
            this.searchTimeout = setTimeout(this.findTarget, TARGET_SEARCH_INTERVAL_MS);
        }
    }

    get attributes () {
        return {
            ...super.attributes,
            'data-target': 'external_target'
        }
    }

    get annotationProps() {
        return {
            ...super.annotationProps,
            targetContainer: this.targetEl
        }
    }

    get targetStyles() {
        return {
            position: 'relative',
            left: '0%',
            top: '0%',
            width: '100%',
            height: '100%'
        }
    }
}